export default class CurveFitting {
  static options = {
    grid: {
      left: "20%",
      top: "40px",
      right: "20%",
      bottom: "20px"
    },
    xAxis: {
      // 直角坐标系 grid 中的 x 轴
      type: "value", // 数值轴
      name: "时间（h）", // 坐标轴名称
      nameTextStyle: {
        fontSize: 16 //设置x轴标题的字体大小
      },
      splitLine: {
        show: false //隐藏
      }
    },
    yAxis: {
      // 直角坐标系 grid 中的 y 轴
      type: "value", // 数值轴
      name: "血药浓度（μg/ml）", // 坐标轴名称
      nameTextStyle: {
        fontSize: 16
      }
    },
    series: [
      {
        // 系列列表
        type: "line", // 折线/面积图
        symbolSize: 6, //折线点的大小
        symbol: "circle", //折线点实心圆
        itemStyle: {
          // 折线拐点标志的样式
          // opacity: 1 // 图形透明度
          normal: {
            color: "#fff", //折线点的颜色
            borderColor: "#FB3E7A", // 拐点边框颜色
            lineStyle: {
              color: "#00A15D", //折线的颜色
              width: 5
            }
          }
        },
        data: [{ value: [0, 0] }],
        markPoint: {
          silent: true,
          symbol: "circle",
          symbolSize: 10,
          itemStyle: {
            color: "#FB3E7A"
          },
          data: [{ coord: [0, 0] }]
        },
        markLine: {
          silent: true,
          symbol: "none",
          data: [
            {
              yAxis: 0
            }
          ]
        }
      }
    ],
    color: ["#1890ff"]
  };

  static getOptions() {
    return this.options;
  }

  static setData(data: [], points: [], line: number) {
    const seriesData = data.map(
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      (element: any) => ({
        value: [element.time, element.concentration]
      })
    );
    this.options.series[0].data = seriesData;

    const markPonts = points.map(
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      (element: any) => ({
        coord: [element.time, element.concentration]
      })
    );
    this.options.series[0].markPoint.data = markPonts;

    this.options.series[0].markLine.data = [{ yAxis: line }];
  }
}
